module.exports = __webpack_public_path__ + "static/media/banner-azul.fbafba91.jpg";